module.exports = "<div class=\"booking-infobox-mobile\">\r\n    <div class=\"totalprice\">Samlet pris <span> {{totalPrice}} DKK</span></div>\r\n</div>\r\n";